import React, {useState, useEffect} from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";

import {
  apollo_useStyles,
  getModalStyle,
  Option,
} from "../../atom/Apollo_styles";
import {Industory, Industorycategory} from "./Apollo_MasterModel";
import {
  apollo_industorycategory_master_path,
  apollo_industory_master_path,
} from "../../atom/Apollo_links";
import {ApolloMessage} from "../../atom/Apollo_Mesasge"
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
// メッセージ定義
import {
  GetMessage,
  UI_MASTER_CATEGORY_MODAL,
} from "../../atom/Apollo_MesasgeDefinition";
// ドロワー(認証期間切れの場合にドロワーを閉じるため)
import {ApolloRightDrawerContext, RightDrawer} from "../../molecule/Apollo_RightDrawer";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

// MODAL
import Card from "@material-ui/core/Card/Card";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import classNames from "classnames";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

// モーダル引数
export type PropsModal = {
  setRead: any
  read: any
  setIndustorycategoryId: any
  industoryId: any
  setIndustoryId: any
  getIndustoryId: any
  productId: any
  setIndustoryName: any
  setCategoryName: any
  clearErr: any
};

interface MasterIndustoryModalProps {
  propsModal:PropsModal
};

// 業種カテゴリ・業種マスタモーダル表示
export default function ApolloMasterIndustoryCategoryModal(props: MasterIndustoryModalProps) {
  // プロパティ
  const {
    setIndustorycategoryId,
    setIndustoryId,
    getIndustoryId,
    productId,
    setIndustoryName,
    setCategoryName,
    clearErr,
  } = props.propsModal;

  // オプション+カテゴリ定義
  type OptionLocal = {
    value: number;
    label: string;
    category: number;
  }

  const classes = apollo_useStyles();
  const buttonClass = classNames(classes.button);
  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(false);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [industorycategory, setIndustorycategory] = React.useState<Industorycategory[]>();
  const [industory, setIndustory] = React.useState<Industory[]>();

  const [optionCategories, setOptionCategories] = React.useState<Option[]>([]);
  const [optionIndustries, setOptionIndustries] = React.useState<OptionLocal[]>([]);
  const [tempIndustries, setTempIndustries] = React.useState<OptionLocal[]>([]);

  const [categoryIdLocal, setCategoryIdLocal] = React.useState<number>(0);
  const [industoryIdLocal, setIndustoryIdLocal] = React.useState<number>(0);

  const [commitDisabled, setCommitDisabled] = React.useState(true);

  // ドロワー(認証期間切れの場合にドロワーを閉じるため)
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  // モーダルスタイル
  const bStyle = {
    top: "40%",
  }

  // 業種カテゴリ・業種マスタ取得
  useEffect(() => {
    // 業種カテゴリ取得
    const urlIndustorycategory = apollo_industorycategory_master_path;
    ApolloAxios.get(urlIndustorycategory).then(response => {
      if (response.data.resultCode === 0) {
        setIndustorycategory(response.data.result);
        createCategoryOption(response.data.result);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_MASTER_CATEGORY_MODAL,"E","0"),
          },
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_MASTER_CATEGORY_MODAL,"E","0"), data, setmsg, history, setDrawerState, drawerState)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });

    // 業種マスタ取得
    const urlIndustory = apollo_industory_master_path;
    ApolloAxios.get(urlIndustory).then(response => {
      if (response.data.resultCode === 0) {
        setIndustory(response.data.result);
        createIndustoryOption(response.data.result);
        setIndustoryIdLocal(industoryIdLocal);
      } else {
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_MASTER_CATEGORY_MODAL,"E","1"),
          },
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_MASTER_CATEGORY_MODAL,"E","1"), data, setmsg, history, setDrawerState, drawerState)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [open]);

  // 初期設定
  const initProc = () => {
    // 新規作成は何もしない
    if (productId === 0) return;
    // 各種リスト初期設定
    initList();
  }

  // 各種リスト初期設定
  const initList = () => {
    // 業種IDから業種カテゴリIDを取得する
    let industoryCategoryIdDefault = 0;
    let id = getIndustoryId();
    industory?.map((data) => {
      if (data.industoryId === id) {
        industoryCategoryIdDefault = data.industorycategoryId;
      }
    });
    // 業種カテゴリリストを作成する
    createCategoryOption(industorycategory ? industorycategory : []);
    // 業種リストを作成する
    createNewOption(industoryCategoryIdDefault);
    // 業種名をセットする
    setIndustoryName(optionIndustries.find((v) => v.value === id)?.label);
    // 業種IDをセットする
    setIndustoryIdLocal(id);
    // 業種カテゴリ名をセットする
    setCategoryName(optionCategories.find((v) => v.value === industoryCategoryIdDefault)?.label);
    // 業種カテゴリIDをセットする
    setCategoryIdLocal(industoryCategoryIdDefault);
  }

  // モーダルクローズハンドラ
  const handleModalClose = () => {
    setOpen(false);
  };

  // モーダルオープンハンドラ
  const handleOpen = () => {
    setOpen(true);
    initProc();
  }

  // 業種カテゴリ変更ハンドラ
  const onChangeOption = (event: any) => {
    createNewOption(event.value);
    setCategoryIdLocal(event.value);
    setIndustoryIdLocal(0);
    setCategoryName(optionCategories.find((v) => v.value === event.value)?.label);
    setCommitDisabled(true);
  }

  // 業種変更ハンドラ
  const handleChangeIndustory = (event: any) => {
    setIndustoryIdLocal(event.value);
    setIndustoryName(optionIndustries.find((v) => v.value === event.value)?.label);
    setCommitDisabled(false);
  };

  // 決定ボタンクリックハンドラ
  const handleClose = () => {
    setIndustoryId(industoryIdLocal);
    setIndustorycategoryId(categoryIdLocal);
    clearErr();
    setOpen(false);
  };

  // 業種カテゴリ選択リスト作成
  function createCategoryOption(industorycategory:Industorycategory[]) {
    var options_category: Option[];
    options_category = industorycategory? industorycategory.map((option) => {
      return {value:option.industorycategoryId, label:option.industorycategoryName}
    }) : [];
    setOptionCategories(options_category);
  }

  // 業種選択リスト作成
  function createIndustoryOption(industory:Industory[]) {
    var options_industory: OptionLocal[];
    options_industory = industory? industory.map((option) => {
      return {value:option.industoryId, label:option.industoryName, category:option.industorycategoryId}
    }) : [];
    setOptionIndustries(options_industory);
  }

  // 業種カテゴリ変更 -> 業種オプション作成
  var newOptionIndustries: OptionLocal[];
  function createNewOption(value:number) {
    newOptionIndustries = []
    optionIndustries.map((option) => {
      if (value === option.category) {
        newOptionIndustries.push(
          {
            value: option.value,
            label: option.label,
            category: option.category,
          }
        );
      }
      return null;
    });
    setTempIndustries(newOptionIndustries);
  }

return (
    <React.Fragment>
      <Button 
        variant="contained"
        color="primary"
        onClick={handleOpen}>
        {"業種カテゴリ検索"}
      </Button>

      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleModalClose}
      >
      <div style={modalStyle} className={classes.paper}>
          <React.Fragment>
            <Card className={classes.root} square variant="outlined" style={{height: 500}}>
                <Box m={1}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      業種カテゴリ
                    </Typography>
                    <Select
                      id="industorycategory"
                      name="industorycategory"
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      key={industorycategory ? "Loaded" : "Loading"}
                      value={categoryIdLocal ? optionCategories.find((v) => v.value === categoryIdLocal) : {value:0, label:""}}
                      options={optionCategories}
                      onChange={(e) => onChangeOption(e)}
                    />
                  </Grid>
                </Box>
                <Box m={1}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      業種
                    </Typography>
                    <Select
                      id="industory"
                      name="industory"
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      key={industory?.length ? "Loaded" : "Loading"}
                      value={industoryIdLocal ? tempIndustries.find((v) => v.value === industoryIdLocal) : {value:0, label:""}}
                      options={tempIndustries}
                      onChange={(e) => handleChangeIndustory(e)}
                    />
                  </Grid>
                </Box>
                <Button onClick={handleClose} variant="outlined" color="primary" className={buttonClass} style={bStyle} disabled={commitDisabled}>
                決定
                </Button>
              <CardActions className={classes.cardaction}>
              </CardActions>
            </Card>
          </React.Fragment>
        </div>
      </Modal>
    </React.Fragment>
  );
}
